import mutations from './mutations';
import actions from './actions';
import getters from './getters';

import createPersistedState from 'vuex-persistedstate';

const state = {

    presentation: false,
	active_presentation: false,
    charts: {},
    active_field: 0,
    active_field_el: false,
	addchart: false,

    chartemplates_loading: false,

	persistedtime_chartemplates: false,


	newchartcounter: 0,

    chartemplates: false,

    editor: {
    	chartcomponents: []
    },
};

export default {
    state,
    mutations,
    actions,
    getters,
    // plugins: [createPersistedState({paths: ['persistedtime_chartemplates', 'chartemplates']})]
};



// WEBPACK FOOTER //
// ./src/store/preseditor/index.js